import { render, staticRenderFns } from "./BizViewer.vue?vue&type=template&id=3e57781f"
import script from "./BizViewer.vue?vue&type=script&lang=js"
export * from "./BizViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports